/**
 * Exhaustive Workflow Actions for Proposals and Promotions.
 * Derived from prmfnd.workflow_transaction ground-truth database schema.
 */

export const PROPOSAL_ACTION = {
  SAVE: 'Save',
  SUBMIT: 'Submit',
  DELETE: 'Delete',
  ACCEPT_DRAFT: 'Accept_Draft',
  ACCEPT_APPROVE: 'Accept_Approve',
  REJECT: 'Reject',
  REJECT_SKU: 'Reject_Sku',
  ACCEPT_MERGE: 'Accept_Merge',
  ACCEPT_WITHDRAW: 'Accept_Withdraw',
  REJECT_WITHDRAW: 'Reject_Withdraw',
  REQUEST_WITHDRAW: 'Request_Withdraw',
  WITHDRAW: 'Withdraw',
  UNMERGE: 'Unmerge',
  ASSIGN: 'Assign',
  BULK_EDIT: 'Bulk_Edit',
  INLINE_EDIT: 'Inline_Edit',
  EDIT_PRP: 'Edit_PRP',
  CLONE_PRP: 'Clone_PRP',
  DOWNLOAD: 'Download',
  LABELS: 'Labels',
  SYSACT_EXPIRE: 'SYSACT_Expire',
} as const;

export type ProposalAction = (typeof PROPOSAL_ACTION)[keyof typeof PROPOSAL_ACTION];

export const PROMOTION_ACTION = {
  SAVE: 'Save',
  APPROVE: 'Approve',
  DELETE: 'Delete',
  DELETE_REJECT: 'Delete_Reject',
  EDIT: 'Edit',
  SAVE_EDIT: 'Save_Edit',
  LIVE_EDIT: 'Liveedit',
  APPROVE_LIVE_EDIT: 'approve_live_edit',
  CANCEL_LIVE_EDIT: 'cancel_live_edit',
  TERMINATE: 'Terminate',
  ASSIGN: 'Assign',
  BULK_EDIT: 'Bulk_Edit',
  CLONE_PRM: 'Clone_PRM',
  DOWNLOAD: 'Download',
  DOWNLOAD_SFM_EXCEL: 'Download_SFM_Excel',
  INV_ADDR: 'InvAddr',
  LABELS: 'Labels',
  ACCEPT_MERGE: 'Accept_Merge',
  SYSACT_LIVE: 'SYSACT_LIVE',
  SYSACT_END: 'SYSACT_END',
} as const;

export type PromotionAction = (typeof PROMOTION_ACTION)[keyof typeof PROMOTION_ACTION];
